import { sharedWritable } from './store';
export const pageState = sharedWritable('page');
export const viewState = sharedWritable('viewState', []);
